import { ParamMap } from '@angular/router';
import { readEnumParam, readIdParam } from '../../core/service/list-query-params';
import { EmailDeliveryStatus } from '../../message/model/const/enums';
import { InvoiceCategory } from '../model/invoice';

export interface InvoiceDrilldownQuery {
  category?: InvoiceCategory;
  emailDeliveryStatus?: EmailDeliveryStatus;
  recipientContactId?: string;
  isExternal: boolean;
  effectiveRecipientOnly: boolean;
}

export function parseInvoiceDrilldownQuery(params: ParamMap): InvoiceDrilldownQuery {
  const category = readEnumParam(params, 'c', InvoiceCategory);
  const emailDeliveryStatus = readEnumParam(params, 'd', EmailDeliveryStatus);
  const recipientContactId = readIdParam(params, 'recipientContactId');
  const effectiveRecipientOnly = !!recipientContactId;

  return {
    category,
    emailDeliveryStatus,
    recipientContactId,
    isExternal: category !== undefined || emailDeliveryStatus !== undefined || effectiveRecipientOnly,
    effectiveRecipientOnly,
  };
}

export function withInvoiceDrilldownFlags(filter: any, ignoreSaveOnLoad: boolean, effectiveRecipientOnly: boolean): any {
  return {
    ...filter,
    ignoreSaveOnLoad: !!ignoreSaveOnLoad,
    effectiveRecipientOnly: !!effectiveRecipientOnly,
  };
}
